module.exports = __webpack_public_path__ + "static/media/arrow-left-unselect.cdb045c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ventajas/arrow-left-unselect.svg
// module id = 177
// module chunks = 0